import React from 'react'
import { Routes, Route } from 'react-router-dom'
import MkRentalOptionsModalTest from './MkRentalOptionsModalTest'

export const TestRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/rental-options-modal"
        element={<MkRentalOptionsModalTest />}
      />
    </Routes>
  )
}
